'use strict';

const CSS_CLASS = 'is-hoverEnabled';

/**
 * Adds `is-hoverEnabled` CSS class to body element.
 */
const saEnableHover = [
  '$document',
  'deviceCapabilities',

  function ($document, deviceCapabilities) {
    return {
      restrict: 'A',
      link: function () {

        // Enable hover if not IOS device
        if (!deviceCapabilities.isIOSDevice) {
          angular.element($document[0].body).addClass(CSS_CLASS);
        }
      }
    };
  }
];

export default saEnableHover;



// WEBPACK FOOTER //
// ./app/src/directives/enable_hover.js